import React from 'react'

import { XMarkIcon } from '@heroicons/react/24/outline'
import Image from 'next/legacy/image'

import genericIcon from '@/assets/file-icons/generic-svgrepo-com.svg'
import imageIcon from '@/assets/file-icons/jpg-svgrepo-com.svg'
import pdfIcon from '@/assets/file-icons/pdf-svgrepo-com.svg'
import pptIcon from '@/assets/file-icons/ppt-svgrepo-com.svg'
import wordIcon from '@/assets/file-icons/txt-svgrepo-com.svg'
import excelIcon from '@/assets/file-icons/xls-svgrepo-com.svg'
import { formatBytes } from '@/utils'

interface FileListPreview {
  files: File[]
  clearFiles?: () => void
}

export function FileListPreview({ files, clearFiles }) {
  const lookup = {
    'application/pdf': pdfIcon,
    'application/vnd.ms-excel': excelIcon,
    'image/png': imageIcon,
    'image/jpg': imageIcon,
    'image/jpeg': imageIcon,
    'application/msword': wordIcon,
    'application/mspowerpoint': pptIcon,
    // Add more file types here...
  }

  return (
    <ul className='p-1 list-none flex flex-col gap-3'>
      {files?.map((file: File, index) => (
        <li
          key={file.name + file.size + file.lastModified + index}
          className='relative border rounded inline-flex gap-3 items-center p-3 bg-gray-50 shadow group'
        >
          <div className='min-w-max'>
            <Image
              src={lookup[file.type] || genericIcon}
              alt='pdf'
              height={32}
              width={32}
            />
          </div>
          <div className='flex-grow'>
            <div className='text-sm'>{file.name}</div>
            <div className='text-xs text-gray-500'>{formatBytes(file.size)}</div>
          </div>

          <button
            onClick={() => clearFiles(file)}
            className='hidden rounded-full p-1 ring-1 ring-black absolute right-0 top-0 -mt-3 -mr-3 bg-gray-200 group-hover:block'
          >
            <XMarkIcon
              width={18}
              height={18}
            />
          </button>
        </li>
      ))}
    </ul>
  )
}
